module.exports = __webpack_public_path__ + "static/media/sprite-v4.a24c2dfd.png";